import * as yup from "yup";

export const contactFormSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .min(1, "First name must be at least 2 characters")
    .max(50, "First name can't exceed 50 characters")
    .required("First name is required"),

  lastName: yup
    .string()
    .trim()
    .min(1, "Last name must be at least 2 characters")
    .max(50, "Last name can't exceed 50 characters")
    .required("Last name is required"),

  email: yup
    .string()
    .trim()
    .email()
    .required("Email is required"),

  mobileNumber: yup
    .string()
    .trim()
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),

  inquiryMadeOnBehalfOf: yup.string().required("Please select an option"),

  reasonForInquiry: yup.string().required("Please select an option"),

  message: yup
    .string()
    .trim()
    .max(255, "Message can't exceed 255 characters"),

  agree: yup.boolean().oneOf([true], "Please verify you're not a robot"),
});
